export interface ResponsePackage<T> {
  status: any;
  message: string;
  data: T;
}

export interface PaginationDto<T> {
  count: number;
  data: T[];
}

export interface OptionObj {
  key: number;
  value: string;
  description?: string;
}

export function getInitOptionObj(): OptionObj {
  return {
    key: 0,
    value: '',
  };
}

export interface MultiSelectObject {
    id: number,
    checked: boolean,
    name: string
}

// Mirrors the backend MonthlyGrowth helper. Only for cards the dashboard consolidates
// from several endpoints — everywhere else the percentage comes straight from the API.
export function calculateIncreasePercentage(countIncrease: number, previousMonthTotal: number): number {
  return previousMonthTotal > 0 ? (countIncrease / previousMonthTotal) * 100 : 0;
}